module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clock-mini"
  }, [_c('div', {
    staticClass: "clock-container"
  }, [_c('div', {
    staticClass: "clock-lg"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.currentTime) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "clocks-small"
  }, [_c('div', {
    staticClass: "clock-local"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.time24h) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "clock-utc"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.timeUtc) + "\n\t\t\t")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-bc777e32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/clock-mini.vue
// module id = 577
// module chunks = 0